<div class="" style="padding: 0 60px;">
    <div class="row mt-3">
        <div class="col-12 d-flex justify-content-between">
            <h6 style="color: #126db3;margin-left:-15px">
                {{"action_plan.analisis.title" | translate}}
            </h6>
            <i *ngIf="!analisis" class="fas fa-chevron-down text-secondary" style="cursor: pointer;margin-left:19px"
                (click)="analisis=!analisis"></i>
            <i *ngIf="analisis" class="fas fa-chevron-up text-secondary" style="cursor: pointer;margin-left:19px"
                (click)="analisis=!analisis"></i>
        </div>
    </div>
</div>
<hr style="margin: 0 40px 10px 40px" />
<div [class]="analisis?null:'d-none'" style="padding: 0 60px;">
    <div class="row bg-white p-4" style="display: flex;align-content: center;">

        <div class="col-12 col-lg-4 ">
            <h6 style="color: #126db3;margin-left:-15px">
                {{"action_plan.analisis.methods" | translate}}
                <button class="fa-stack fa-1x ml-lg-2 cursor" (click)="openMethods()"
                    style="font-size: 13px;border:none;background: none;">
                    <i class="fa fa-circle fa-stack-2x icon-background"></i>
                    <i class="fas fa-plus fa-stack-1x"></i>
                </button>
            </h6>
            <!-- <select name="" id="" class="col-12 form-control form-grey" [(ngModel)]="methodSelected"
                (change)="methodSelected()">
                <option value="1"> {{"action_plan.analisis.methods_diagram.ishikawa_diagram" | translate}}</option>
                <option value="2">{{"action_plan.analisis.methods_diagram.pareto_chart" | translate}}</option>
                <option value="3">{{"action_plan.analisis.methods_diagram.five_why_diagram" | translate}}</option>
            </select> -->
        </div>
    </div>
    <div class="row bg-white mt-3 p-4" *ngIf="methodSelected.length">
        <div class="col-12 form-grey" style="overflow-x: hidden;">

            <ng-container *ngFor="let method of methodSelected;first as isFirst">
                <!-- ISHIKAWA -->
                <div [class]="isFirst?'row bg-white':'row bg-white mt-2'" *ngIf="method.metodo_analisis.id==1">
                    <div class="col-12 d-flex justify-content-between border-bottom py-2">
                        <div class="">
                            <h6 style="color: #126db3;margin-left:-15px">
                                {{"action_plan.analisis.methods_diagram.ishikawa_diagram" | translate}}
                            </h6>
                        </div>
                        <div class="">
                            <button class="fa-stack fa-1x ml-2 cursor"
                                (click)="deleteMethod(method.id,method.metodo_analisis.id,method.metodo_analisis.nombre)"
                                style="font-size: 13px;border:none;background: none;">
                                <i class="fa fa-circle fa-stack-2x icon-background dangerIcon"></i>
                                <i class="fas fa-times fa-stack-1x"></i>
                            </button>
                            <i *ngIf="ishikawa" class="fas fa-chevron-down text-secondary"
                                style="cursor: pointer;margin-left:19px" (click)="ishikawa=!ishikawa"></i>
                            <i *ngIf="!ishikawa" class="fas fa-chevron-up text-secondary"
                                style="cursor: pointer;margin-left:19px" (click)="ishikawa=!ishikawa"></i>
                        </div>


                    </div>
                    <div [class]="ishikawa?'col-12':'d-none'">
                        <sieni-ishikawa-diagram [showTitle]=false [showCustomButton]=false [lang]="lang"  [info]="method.informacion_extra"
                            [data]="method.causas" (emitCustomService)="module($event)" (emitInfoService)="infoChanges($event,'ishikawa')"
                            (emitDataService)="methodChanges($event,'ishikawa')" style="margin: 2%">
                        </sieni-ishikawa-diagram>
                    </div>
                </div>
                <!-- FIVE-WHY -->
                <div [class]="isFirst?'row bg-white':'row bg-white mt-2'" *ngIf="method.metodo_analisis.id==2">
                    <div class="col-12 d-flex justify-content-between border-bottom pt-4 pb-3">
                        <div class="">
                            <h6 style="color: #126db3;margin-left:-15px">
                                {{"action_plan.analisis.methods_diagram.five_why_diagram" | translate}}
                            </h6>
                        </div>
                        <div class="">
                            <button class="fa-stack fa-1x ml-2 cursor"
                                (click)="deleteMethod(method.id,method.metodo_analisis.id,method.metodo_analisis.nombre)"
                                style="font-size: 13px;border:none;background: none;">
                                <i class="fa fa-circle fa-stack-2x icon-background dangerIcon"></i>
                                <i class="fas fa-times fa-stack-1x"></i>
                            </button>
                            <i *ngIf="fiveWhy" class="fas fa-chevron-down text-secondary"
                                style="cursor: pointer;margin-left:19px" (click)="fiveWhy=!fiveWhy"></i>
                            <i *ngIf="!fiveWhy" class="fas fa-chevron-up text-secondary"
                                style="cursor: pointer;margin-left:19px" (click)="fiveWhy=!fiveWhy"></i>
                        </div>


                    </div>
                    <div [class]="fiveWhy?'col-12':'d-none'">
                        <sieni-five-why-diagram [lang]="lang" [showTitle]=false [showCustomButton]=false [title]="planSelected.situacion_tratar"
                            [data]="method.causas" (emitCustomService)="module($event)" style="margin: 2%"
                            (emitDataService)="methodChanges($event,'five')">
                        </sieni-five-why-diagram>
                    </div>
                </div>
                <!-- PARETO -->
                <div [class]="isFirst?'row bg-white':'row bg-white mt-2'" *ngIf="method.metodo_analisis.id==3">
                    <div class="col-12 d-flex justify-content-between border-bottom pt-4 pb-3">
                        <div class="">
                            <h6 style="color: #126db3;margin-left:-15px">
                                {{"action_plan.analisis.methods_diagram.pareto_chart" | translate}}
                            </h6>
                        </div>
                        <div class="">
                            <button class="fa-stack fa-1x ml-2 cursor"
                                (click)="deleteMethod(method.id,method.metodo_analisis.id,method.metodo_analisis.nombre)"
                                style="font-size: 13px;border:none;background: none;">
                                <i class="fa fa-circle fa-stack-2x icon-background dangerIcon"></i>
                                <i class="fas fa-times fa-stack-1x"></i>
                            </button>
                            <i *ngIf="pareto" class="fas fa-chevron-down text-secondary"
                                style="cursor: pointer;margin-left:19px" (click)="pareto=!pareto"></i>
                            <i *ngIf="!pareto" class="fas fa-chevron-up text-secondary"
                                style="cursor: pointer;margin-left:19px" (click)="pareto=!pareto"></i>
                        </div>


                    </div>
                    <div [class]="pareto?'col-12':'d-none'">
                        <sieni-pareto-chart [lang]="lang" [showTitle]=false [showCustomButton]=false  [paretoConfiguration]="infoPareto" [data]="method.causas"
                            (emitCustomService)="module($event)" style="margin: 2%" (emitParetoConfigService)="infoChanges($event,'pareto')" (emitParetoTitleService)="infoChanges($event,'paretoTitle')"
                            (emitDataService)="methodChanges($event,'pareto')">
                        </sieni-pareto-chart>
                    </div>
                </div>
                <div [class]="isFirst?'row bg-white':'row bg-white mt-2'" *ngIf="method.metodo_analisis.id==4">
                    <div class="col-12 d-flex justify-content-between border-bottom pt-4 pb-3">
                        <div class="">
                            <h6 style="color: #126db3;margin-left:-15px">
                                {{"action_plan.analisis.methods_diagram.brainstorm" | translate}}
                            </h6>
                        </div>
                        <div class="">
                            <button class="fa-stack fa-1x ml-2 cursor"
                                (click)="deleteMethod(method.id,method.metodo_analisis.id,method.metodo_analisis.nombre)"
                                style="font-size: 13px;border:none;background: none;">
                                <i class="fa fa-circle fa-stack-2x icon-background dangerIcon"></i>
                                <i class="fas fa-times fa-stack-1x"></i>
                            </button>
                            <i *ngIf="Brainstorm" class="fas fa-chevron-down text-secondary"
                                style="cursor: pointer;margin-left:19px" (click)="Brainstorm=!Brainstorm"></i>
                            <i *ngIf="!Brainstorm" class="fas fa-chevron-up text-secondary"
                                style="cursor: pointer;margin-left:19px" (click)="Brainstorm=!Brainstorm"></i>
                        </div>


                    </div>
                    <div [class]="Brainstorm?'col-12':'d-none'">
                        <sieni-brainstorm [lang]="lang" [showTitle]=false [showCustomButton]=false [title]="planSelected.situacion_tratar" [data]="method.causas"
                            [criteria]="method.criterios" (emitCustomService)="module($event)" style="margin: 2%"
                            (emitDataService)="methodChanges($event,'brainstorm')"
                            (emitCriterioService)="criteriosService($event)">
                        </sieni-brainstorm>
                    </div>
                </div>

            </ng-container>


        </div>
        <div class="row col-12" style="padding:0 1px 0 36px;">
            <div class="col-12 d-flex justify-content-between">
                <h6 style="color: #126db3;margin-left:-15px">
                    {{"action_plan.analisis.selected" | translate}}
                </h6>
                <i *ngIf="!selectedCauses" class="fas fa-chevron-down text-secondary"
                    style="cursor: pointer;margin-left:19px" (click)="selectedCauses=!selectedCauses"></i>
                <i *ngIf="selectedCauses" class="fas fa-chevron-up text-secondary"
                    style="cursor: pointer;margin-left:19px" (click)="selectedCauses=!selectedCauses"></i>
            </div>
            <div *ngIf="selectedCauses" class="col-12 mt-2" style="color: #126db3;">
                <div class="row">
                    <div class="col-2 col-lg-1">
                        <span style="margin-left: -10px;">{{"action_plan.analisis.nro" | translate}}</span>
                    </div>
                    <div class="col-6 col-lg-7 mleft">
                        <span style="margin-left: -20px;">{{"action_plan.analisis.cause" | translate}}</span>
                    </div>
                    <div class="col-4">
                        <span style="margin-left: -11px;">{{"action_plan.analisis.method" | translate}}</span>
                    </div>
                </div>

            </div>
            <div *ngIf="selectedCauses" class="col-12 form-grey pl-3 pr-4 pt-2"
                style="height: 150px;overflow-y:scroll;overflow-x: hidden;">
                <ng-container *ngIf="definitiveSelected.length">
                    <ng-container *ngFor="let d of definitiveSelected; index as i; first as isFirst">
                        <div class="row form-grey">
                            <div class="col-2 col-lg-1">{{i + 1}}</div>
                            <div class="col-6 col-lg-7 mleft"><span style="margin-left: -16px;"> {{d?.description}}</span></div>
                            <div class="col-4 d-flex justify-content-between">
                                <span *ngIf="d?.method.id==1"> {{"action_plan.analisis.methods_diagram.ishikawa_diagram"
                                    | translate}} </span>
                                <span *ngIf="d?.method.id==2"> {{"action_plan.analisis.methods_diagram.five_why_diagram"
                                    | translate}} </span>
                                <span *ngIf="d?.method.id==3"> {{"action_plan.analisis.methods_diagram.pareto_chart" |
                                    translate}} </span>
                                <span *ngIf="d?.method.id==4"> {{"action_plan.analisis.methods_diagram.brainstorm" |
                                    translate}} </span>
                                <label class="customCheckbox">
                                    <input type="checkbox" [(ngModel)]="d.gralSelected" (change)="saveDefinitiveCauses()" />
                                    <span></span>
                                </label>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>

            </div>
        </div>

    </div>
    <div class="col-md-4 ml-auto mt-3 mt-lg-5 btns d-flex p-0 flex-row-reverse">

        <button class="btn  m-2 acceptButton text-white" [disabled]="loading" (click)="saveMethods('save')">

            <ng-container *ngIf="!loading;else spinner">
                {{ "globals.buttons.save" | translate }}
            </ng-container>
            <ng-template #spinner>
                <fa-icon icon="spinner" [spin]="true"></fa-icon>
            </ng-template>
        </button>
        <button class="btn  m-2 dangerButton text-white">
            {{ "globals.buttons.cancelar" | translate }}
        </button>
    </div>
</div>